import { LeadAssignmentFilters, LeadAssignmentsTabs } from "../index";
import { FilterOpts } from "pages/OrderPages/OrderListPage/OrderListPage.tsx";
import SuggestedSearch from "components/Common/SuggestedSearch/SuggestedSearch.tsx";
import { models } from "types/api/viewModels.ts";
import * as Text from "../../LeadAssignmentsPage.text";
import { Dispatch, SetStateAction } from "react";
import { LeadAssignmentsTab } from "../LeadAssignmentsTabs/LeadAssignmentsTabs.tsx";
import { LeadDateFilterOption } from "../../utils";
import LeadAssignmentsDateFilter from "./LeadAssignmentsDateFilter.tsx";
import {
	LeadAssignmentsPageFilterContainer,
	LeadAssignmentsPageToolbarContainer
} from "./LeadAssignmentsToolbar.styles.ts";

export interface LeadAssignmentsToolbarProps {
	currentTab: LeadAssignmentsTab;
	isAdmin?: boolean;
	handleTabChange?: (tab: LeadAssignmentsTab) => void;
	handleTabToggle?: () => void;
	filterOptions: FilterOpts;
	setFilterOptions: Dispatch<SetStateAction<FilterOpts>>;
	leads: models["LeadAssignmentViewModel"][];
	searchOptions: string[];
	searchValue: string;
	handleSearch: (_e: unknown, value: string | null) => void;
	selectedDateFilter: LeadDateFilterOption;
	handleDateFilterChange: (value: LeadDateFilterOption) => void;
}

export const LeadAssignmentsToolbar = ({
	currentTab,
	isAdmin = false,
	handleTabChange,
	handleTabToggle,
	filterOptions,
	setFilterOptions,
	leads,
	searchOptions,
	searchValue,
	handleSearch,
	selectedDateFilter,
	handleDateFilterChange
}: LeadAssignmentsToolbarProps) => {
	return (
		<LeadAssignmentsPageToolbarContainer data-testid="lead-assignments-toolbar">
			<LeadAssignmentsTabs
				currentTab={currentTab}
				isAdmin={isAdmin}
				handleTabChange={handleTabChange}
				toggleLeads={handleTabToggle}
			/>
			<LeadAssignmentsPageFilterContainer>
				<LeadAssignmentsDateFilter
					selectedDateFilter={selectedDateFilter}
					onChange={handleDateFilterChange}
				/>
				<LeadAssignmentFilters
					filterOptions={filterOptions}
					setFilterOptions={setFilterOptions}
					leads={leads}
				/>
				<SuggestedSearch
					ariaLabel={Text.SearchLeadsAriaLabel}
					dataTestId="assigned-leads-search-bar"
					dropDownOpenOnChar={0}
					placeholder={Text.SearchLeadsPlaceholder}
					id="assigned-leads-search-bar"
					searchOptions={searchOptions}
					searchValue={searchValue}
					handleSearch={handleSearch}
					size="small"
				/>
			</LeadAssignmentsPageFilterContainer>
		</LeadAssignmentsPageToolbarContainer>
	);
};
